import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { extractRelativeUrl } from '../../../../utils';
import BackNavButton from '../../components/BackNavButton';
import './style.scss';
import { t } from '../../../../locales';

export interface BackNavButtonContainerProps {
  onGoBack?: () => any;
  blue?: boolean;
  isShowBackButton?: boolean;
}

export interface BackNavButtonContainerState {
  isShowBackButton: boolean;
}

export class BackNavButtonContainer extends Component<
  BackNavButtonContainerProps,
  BackNavButtonContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isShowBackButton: false,
    };
  }

  componentDidMount() {
    const { isShowBackButton } = this.props;

    this.setState({
      isShowBackButton:
        isShowBackButton !== undefined ? isShowBackButton : true,
    });
  }

  render() {
    const { onGoBack, blue = false } = this.props;
    const { isShowBackButton, ...rest } = this.state;

    return (
      <>
        {isShowBackButton && (
          <div className="customer-profile-backbutton">
            <BackNavButton
              onClick={onGoBack}
              title={t('BACK')}
              {...rest}
              blue={blue}
            />
          </div>
        )}
      </>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  BackNavButtonContainer.mapStateToProps,
  BackNavButtonContainer.mapDispatchToProps,
)(BackNavButtonContainer);
